var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 15.4167C14.4573 15.4167 15.1355 15.1357 15.6356 14.6356C16.1357 14.1355 16.4167 13.4573 16.4167 12.75C16.4167 12.0428 16.1357 11.3645 15.6356 10.8644C15.1355 10.3643 14.4573 10.0834 13.75 10.0834L6.0809 10.0834L8.04046 12.0429C8.43098 12.4334 8.43098 13.0666 8.04046 13.4571C7.64994 13.8477 7.01677 13.8477 6.62625 13.4571L2.95958 9.79046C2.56906 9.39994 2.56906 8.76677 2.95958 8.37625L6.62625 4.70958C7.01677 4.31906 7.64994 4.31906 8.04046 4.70958C8.43098 5.1001 8.43098 5.73327 8.04046 6.12379L6.0809 8.08335L13.75 8.08335C14.9877 8.08335 16.1747 8.57502 17.0499 9.45019C17.925 10.3254 18.4167 11.5123 18.4167 12.75C18.4167 13.9877 17.925 15.1747 17.0499 16.0499C16.1747 16.925 14.9877 17.4167 13.75 17.4167H12.8334C12.2811 17.4167 11.8334 16.969 11.8334 16.4167C11.8334 15.8644 12.2811 15.4167 12.8334 15.4167H13.75Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackwardIcon);
export default __webpack_public_path__ + "static/media/ArrowBackwardIcon.5a6a413e7eff5347557eade73a5596d6.svg";
export { ForwardRef as ReactComponent };